import { createContext } from "react";

export const Dashboard = createContext()